// Polyfills for IE11, including only what's necessary in order to save bundle size
import 'core-js/features/promise';
import 'core-js/features/string';
import 'core-js/features/object';
import 'core-js/features/array';
import 'core-js/features/math';
import 'core-js/features/map';
import 'core-js/features/set';
import 'core-js/features/weak-set';
import 'core-js/features/function';
import 'core-js/features/number';
import 'core-js/web/url';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { initializeAuth } from 'effects/auth';
import App from './App';
import configureStore from './configureStore';
import * as serviceWorker from './serviceWorker';

const store = configureStore();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

/*
The authentication redirect has to be consumed before the first render. A component that asks
for the current account too early sees a returning user as signed out and starts a second,
avoidable trip to the identity provider.
*/
const start = async (): Promise<void> => {
  try {
    await initializeAuth();
  } catch (err) {
    console.error('Unable to initialize authentication', err);
  }

  root.render(<App store={store} />);
};

start();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
